import { Button, Checkbox, Label, Popover } from "flowbite-react";
import { FC, useState } from "react";
import { HiViewColumns } from "react-icons/hi2";
import { UserSortField } from "./list";

export interface ColumnConfig {
  id: UserSortField | "actions";
  label: string;
  enabled: boolean;
}

interface ColumnSelectorProps {
  columns: ColumnConfig[];
  onColumnsChange: (columns: ColumnConfig[]) => void;
}

const ColumnSelector: FC<ColumnSelectorProps> = ({
  columns,
  onColumnsChange,
}) => {
  const [open, setOpen] = useState(false);

  const handleColumnToggle = (columnId: UserSortField | "actions") => {
    const updatedColumns = columns.map((col) =>
      col.id === columnId ? { ...col, enabled: !col.enabled } : col,
    );
    onColumnsChange(updatedColumns);
  };

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      content={
        <div className="w-64 p-3">
          <div className="mb-3 text-sm font-semibold text-gray-900 dark:text-white">
            Show columns
          </div>
          <div className="space-y-2">
            {columns.map((column) => (
              <div key={column.id} className="flex items-center">
                <Checkbox
                  id={`column-${column.id}`}
                  checked={column.enabled}
                  onChange={() => handleColumnToggle(column.id)}
                  className="mr-2"
                />
                <Label
                  htmlFor={`column-${column.id}`}
                  className="cursor-pointer text-sm font-normal text-gray-700 dark:text-gray-300"
                >
                  {column.label}
                </Label>
              </div>
            ))}
          </div>
        </div>
      }
    >
      <Button color="gray">
        <HiViewColumns className="mr-2 h-4 w-4" />
        Columns
      </Button>
    </Popover>
  );
};

export default ColumnSelector;
